import {executeQuery} from "@/main";
import {useUserStore} from "@/store/userStore";
import countries from 'raw-loader!./graphql/query/countries.graphqls';
import organisationTypes from 'raw-loader!./graphql/query/organisationTypes.graphqls';
import validateEmail from 'raw-loader!./graphql/query/validateEmail.graphqls';
import registerContact from 'raw-loader!./graphql/mutation/registerContact.graphqls';
import accountsByCountry from 'raw-loader!./graphql/query/accountsByCountry.graphqls';
import formById from 'raw-loader!./graphql/query/formById.graphqls';
import submitForm from 'raw-loader!./graphql/mutation/submitForm.graphqls';
import interviewRequest from 'raw-loader!./graphql/mutation/interviewRequest.graphqls';
import insertResearchProject from 'raw-loader!./graphql/mutation/insertResearchProject.graphqls';
import axios from "axios";


export default class AppService {
    countries() {
        return executeQuery(null, countries)
    }

    organisationTypes() {
        return executeQuery(null, organisationTypes)
    }

    validateEmail(email) {
        return executeQuery(null, validateEmail, {email})
    }

    accountsByCountry(country) {
        return executeQuery(null, accountsByCountry, {country})
    }

    registerContact(registration) {
        return executeQuery(null, registerContact, {registration})
    }

    interviewRequest(request) {
        return executeQuery(null, interviewRequest, {request})
    }

    form(id) {
        return executeQuery(null, formById, {id})
    }

    submitForm(form, contactId, utmSource, utmMedium, utmCampaign, uniqueReference) {
        return executeQuery(null, submitForm, {form, contactId, utmSource, utmMedium, utmCampaign, uniqueReference})
    }

    insertResearchProject(form) {
        const userStore = useUserStore()
        if (userStore.user && userStore.user.token != null) {
            return executeQuery(userStore.user.token, insertResearchProject, {researchProject: form})
        }
    }
    researchProjects() {
        return axios.get("https://kontent.eks-prod.aws.esmo.org/rest/items?system.workflow_step[neq]=archived" +
            "&system.type=research_project&includeTotalCount=true&order=system.last_modified[desc]").then(researchProjects => {
                const response = researchProjects.data
                return response?.items?.map(researchProject => {
                    researchProject.elements.owner = { ...response.modular_content[researchProject.elements.owner?.value?.at(0)] }
                    return researchProject
                });
        })
    }
}